'use strict';
import getIndices from './get_indices';
export default (terms, stem, word, text) => {
    let term = terms[stem];
    if (!term) {
        term = terms[stem] = {
            stem,
            minSize: stem.length,
            maxSize: stem.length,
            count: 0,
            words: {},
        };
    }
    if (term.words[word]) {
        return;
    }
    const indices = getIndices(word, text);
    if (word.length > term.maxSize) {
        term.maxSize = word.length;
    }
    term.words[word] = indices;
    term.count += indices.length;
};
//# sourceMappingURL=add_word_into_term.js.map